import {EntityState} from '@modifi/redux/lib/esm/factories/entity/reducer'
import {IndustryView} from '@modifi/onboarding-api-clients'
import reducer from './entity'

export default reducer

// @ts-expect-error to be fixed
export type IndustryState = EntityState<IndustryView[]>
